import './css/styles.scss';

function sidhuvudMedbildInit() {}

sidhuvudMedbildInit();
